
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 72.36 13.09\" id=\"pull-tab-bottom\" ><title>Asset 1</title><g data-name=\"Layer 2\"><path d=\"M71 4.15H53.21a1.37 1.37 0 0 1 0-2.75H71a1.37 1.37 0 0 1 0 2.75zM71 10.45H52.21a1.38 1.38 0 0 1 0-2.75H71a1.38 1.38 0 0 1 0 2.75zM19.15 4.15H1.38a1.38 1.38 0 0 1 0-2.75h17.77a1.37 1.37 0 0 1 0 2.75zM20.15 10.45H1.38a1.38 1.38 0 0 1 0-2.75h18.77a1.38 1.38 0 0 1 0 2.75zM36.18 13.09a1.37 1.37 0 0 1-1-.47L26.07 2.28A1.37 1.37 0 1 1 28.13.47l8 9.16 8-9.16a1.37 1.37 0 1 1 2.07 1.81l-8.99 10.34a1.38 1.38 0 0 1-1.03.47z\"/></g></symbol>";
module.exports = sprite.add(image, "pull-tab-bottom");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pull-tab-bottom.svg
// module id = 309
// module chunks = 1